import bowlPng from './bowl.png';
import bowlWebP from './bowl.webp';
import bowlJp2 from './bowl.jp2';

export default [bowlWebP, bowlJp2, bowlPng];
